import { VOP_VALIDATE_CODES } from '../constant'

const status = [
  {
    code: VOP_VALIDATE_CODES.FULL_MATCH,
    descs: ["app.payments.vop.helptext.fullMatch.desc"],
  },
  {
    code: VOP_VALIDATE_CODES.CLOSED_MATCH,
    descs: [
      "app.payments.vop.helptext.closedMatch.desc1",
      "app.payments.vop.helptext.closedMatch.desc2",
    ],
  },
  {
    code: VOP_VALIDATE_CODES.NO_MATCH,
    descs: [
      "app.payments.vop.helptext.noMatch.desc1",
      "app.payments.vop.helptext.noMatch.desc2",
      "app.payments.vop.helptext.noMatch.desc3",
    ],
  },
  {
    code: VOP_VALIDATE_CODES.VER_FAILED,
    descs: [
      "app.payments.vop.helptext.verFailed.desc1",
      "app.payments.vop.helptext.verFailed.desc2",
    ],
  },
];

export default status;